import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from "../utils/functions";

const $postListEl = $('.post-list');

$(function () {
    if ($postListEl.length > 0) {
        $postListEl.each(function () {
            const $thisEl = $(this);
            postList($thisEl);
        });
    }
});

const postList = (listEl) => {
    const filter = {
        page: 1,
        limit: listEl.data('limit'),
        categories: listEl.data('categories'),
        tags: listEl.data('tags'),
        search: -1,
        category: -1,
        tag: -1,
        year: -1,
        lang: $postListEl.data('lang'),
    };

    bindPosts(listEl, filter);
    bindPostFilter(listEl, filter);
};

const reRenderList = async (element, filter, scrollTop = false) => {
    const data = await getPosts(filter);
    element.find('.post-list__content').html(data.html);

    if (scrollTop === true) {
        smoothscroll($postListEl);
    }
};

const bindPosts = (element, filter) => {
    element.on('click', '.pagination__item', function () {
        const $thisEl = $(this);
        filter.page = $thisEl.data('page');
        reRenderList(element, filter, true);
    });
};

const bindPostFilter = (element, filter) => {
    element.on('change', "select[name='select-post-years']", function () {
        const $thisEl = $(this);
        filter.page = 1;
        filter.year = $thisEl.val();
        filter.category = element.find("select[name='select-post-categories']").val();
        filter.tag = element.find("select[name='select-post-tags']").val();
        console.log(element.find("input[name='input-post-search']"));
        console.log(element.find("input[name='input-post-search']").val());
        filter.search = element.find("input[name='input-post-search']").val();
        reRenderList(element, filter);
    });

    element.on('change', "select[name='select-post-categories']", function () {
        const $thisEl = $(this);
        filter.page = 1;
        filter.category = $thisEl.val();
        filter.tag = element.find("select[name='select-post-tags']").val();
        filter.year = element.find("select[name='select-post-years']").val();
        filter.search = element.find("input[name='input-post-search']").val();
        reRenderList(element, filter);
    });
    
    element.on('change', "select[name='select-post-tags']", function () {
        const $thisEl = $(this);
        filter.page = 1;
        filter.tag = $thisEl.val();
        filter.category = element.find("select[name='select-post-categories']").val();
        filter.year = element.find("select[name='select-post-years']").val();
        filter.search = element.find("input[name='input-post-search']").val();
        reRenderList(element, filter);
    });

    element.on('input', "input[name='input-post-search']" ,debounce(function () {
        const $thisEl = $(this);
        filter.page = 1;
        filter.tag = element.find("select[name='select-post-tags']").val();
        filter.category = element.find("select[name='select-post-categories']").val();
        filter.year = element.find("select[name='select-post-years']").val();
        filter.search = $thisEl.val();
        reRenderList(element, filter);
    }));
    
    element.on('click', "button[name='remove-post-filter']", function () {
        const $thisEl = $(this);
        filter.page = 1;
        filter.year = -1;
        filter.category = -1;
        filter.tag = -1;
        filter.search = -1;
        
        $thisEl.parent().parent().parent().find("select[name='select-post-categories']").val('-1');
        $thisEl.parent().parent().parent().find("select[name='select-post-tags']").val('-1');
        $thisEl.parent().parent().parent().find("select[name='select-post-years']").val('-1');
        $thisEl.parent().parent().parent().find("input[name='input-post-search']").val('');

        reRenderList(element, filter);
    });
};

const getPosts = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/kvop/v1/post-list/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
